<div class="landing">

  <!-- Hero -->
  <section class="hero">
    <div class="hero-content">
      <h1>Welcome to the SAGE Data Space Connector</h1>
      <p class="hero-lead">This portal is your gateway to the SAGE Green Deal Data Space.</p>
      <p class="hero-intro">
        Discover, access and exchange environmental data securely and in a trusted way
        across organizations and borders.
      </p>
      <p class="hero-body">
        SAGE — the Data Space for a Sustainable Green Europe — builds a federated, secure and
        interoperable ecosystem that enables data sharing and reuse to accelerate the
        European Green Deal.
      </p>

      <div class="hero-actions">
        <a mat-flat-button class="btn-primary" [href]="aboutUrl" target="_blank" rel="noopener">
          <mat-icon>eco</mat-icon> About SAGE
        </a>
        <a mat-stroked-button class="btn-ghost" [href]="documentationUrl" target="_blank" rel="noopener">
          <mat-icon>menu_book</mat-icon> Documentation
        </a>
        <a *ngIf="onboardingPortalUrl" mat-stroked-button class="btn-ghost"
           [href]="onboardingPortalUrl" target="_blank" rel="noopener">
          <mat-icon>groups</mat-icon> Onboarding
        </a>
      </div>
    </div>

    <div class="hero-art" aria-hidden="true">
      <img src="assets/brand/sage-mark-green.png" alt=""/>
    </div>
  </section>

  <!-- Two columns -->
  <div class="columns">

    <section class="panel">
      <h2>What you can do with this connector</h2>
      <a class="capability" *ngFor="let cap of capabilities" [routerLink]="[cap.link]">
        <mat-icon>{{cap.icon}}</mat-icon>
        <span>{{cap.label}}</span>
        <mat-icon class="chevron">chevron_right</mat-icon>
      </a>
    </section>

    <section class="panel">
      <h2>SAGE focuses on key Green Deal priorities</h2>
      <div class="priorities">
        <div class="priority" *ngFor="let p of priorities">
          <div class="priority-icon" [ngClass]="'tone-' + p.tone">
            <mat-icon>{{p.icon}}</mat-icon>
          </div>
          <div class="priority-title" [ngClass]="'tone-' + p.tone">{{p.title}}</div>
          <div class="priority-desc">{{p.description}}</div>
        </div>
      </div>
    </section>
  </div>

  <!-- Learn more band -->
  <section class="learn-more">
    <div class="learn-icon"><mat-icon>public</mat-icon></div>
    <div class="learn-text">
      <div class="learn-title">Learn more about SAGE</div>
      <div class="learn-body">Visit the SAGE website for the latest news, resources and ways to get involved.</div>
    </div>
    <a mat-stroked-button class="btn-ghost" [href]="websiteUrl" target="_blank" rel="noopener">
      <mat-icon>open_in_new</mat-icon> greendealdata.eu
    </a>
  </section>

  <!-- Footer -->
  <footer class="landing-footer">
    <img class="footer-mark" src="assets/brand/sage-mark-green.png" alt=""/>
    <div class="footer-text">
      <div class="footer-title">SAGE — The Data Space for a Sustainable Green Europe</div>
      <div class="footer-body">
        Building a trusted, federated and interoperable Green Deal Data Space
        for secure environmental data sharing across Europe.
      </div>
    </div>
    <a class="footer-link" [href]="websiteUrl" target="_blank" rel="noopener">www.greendealdata.eu</a>
  </footer>
</div>
